export default action_type => (payload = {}) => ({ type: action_type, payload });
